module.exports = __webpack_public_path__ + "img/people-21.ac5167b2.png";